const PUBLIC_URL = (process.env.PUBLIC_URL || "").replace(/\/+$/, "");

export const DEFAULT_AVATAR_IMAGE_URL = `${PUBLIC_URL}/static/img/users/blank_avatar_image.jpg`;

export const DEFAULT_PROFILE_IMAGE_URL = `${PUBLIC_URL}/static/img/users/blank_profile_image.jpg`;

type UserAvatarImages = {
  avatarLarge?: string | null;
  avatarMedium?: string | null;
  avatarSmall?: string | null;
};

type UserProfileImages = {
  profilePictureLarge?: string | null;
  profilePictureMedium?: string | null;
  profilePictureSmall?: string | null;
};

export const getUploadedUserAvatarSrc = (user?: UserAvatarImages | null) =>
  user?.avatarLarge || user?.avatarMedium || user?.avatarSmall || "";

export const getUserAvatarSrc = (user?: UserAvatarImages | null) =>
  getUploadedUserAvatarSrc(user) || DEFAULT_AVATAR_IMAGE_URL;

export const getUploadedUserProfilePictureSrc = (
  user?: UserProfileImages | null
) =>
  user?.profilePictureLarge ||
  user?.profilePictureMedium ||
  user?.profilePictureSmall ||
  "";

export const getUserProfilePictureSrc = (user?: UserProfileImages | null) =>
  getUploadedUserProfilePictureSrc(user) || DEFAULT_PROFILE_IMAGE_URL;
